import Controller from '@ember/controller';
import { action, computed, get, set, setProperties } from '@ember/object';
import { notEmpty, sort } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { scrollToTop } from 'donor-elf-web/lib/view-utils';
import { task } from 'ember-concurrency';
import RSVP from 'rsvp';

export default Controller.extend({
  router: service(),
  settings: service(),
  store: service(),
  storeCache: service(),

  queryParams: ['q'],
  q: '',
  errorMessage: null,
  page: 1,
  perPage: 100,

  filterApplied: notEmpty('q'),

  sortBy: ['fund.name:asc'],
  sortedItems: sort('model.fundItems', 'sortBy'),

  filteredItems: computed('q', 'sortedItems.[]', function () {
    let { q, sortedItems } = this;
    if (isEmpty(q)) {
      return sortedItems;
    }
    q = q.toLowerCase();
    return sortedItems.filter((item) => {
      return get(item, 'fund.nameLowerCase').indexOf(q) >= 0;
    });
  }),
  pagedItems: computed('page', 'perPage', 'filteredItems', function () {
    let offset = (this.page - 1) * this.perPage;
    return this.filteredItems.slice(offset, offset + this.perPage);
  }),
  totalPages: computed('filteredItems', 'perPage', function () {
    return Math.ceil(this.filteredItems.length / this.perPage);
  }),

  selectedItems: computed('sortedItems.@each.isSelected', function () {
    return this.sortedItems.filter((item) => {
      return get(item, 'isSelected');
    });
  }),

  save: task(function* () {
    let store = this.store;
    let fundGroupId = get(this, 'model.fundGroup.id');
    let promises = [];
    try {
      get(this, 'model.fundItems').forEach((fundItem) => {
        if (get(fundItem, 'isSelected')) {
          if (isEmpty(get(fundItem, 'fundGroupFund'))) {
            let record = store.createRecord('admin/fund-group-fund', {
              fundGroupId: fundGroupId,
              fundId: get(fundItem, 'fund.id'),
            });

            promises.push(record.save());
          }
        } else if (!isEmpty(get(fundItem, 'fundGroupFund'))) {
          promises.push(get(fundItem, 'fundGroupFund').destroyRecord());
        }
      });
      yield RSVP.all(promises);
      yield this.model.fundGroup.reload();
      this.router.transitionTo('admin.fund-groups.fund-group');
    } catch (e) {
      set(
        this,
        'errorMessage',
        'Whoops! There was an error saving. Please refresh the page and try again. If it continues to happen please email us to let us know.',
      );
    }
  }).drop(),

  reset() {
    setProperties(this, {
      q: '',
      page: 1,
      errorMessage: null,
    });
  },

  applyFilter: action(function (q) {
    setProperties(this, {
      q,
      page: 1,
    });
  }),

  changePage: action(function (pageNumber) {
    set(this, 'page', pageNumber);
    scrollToTop();
  }),
});
